import ProjectSettingsScreen from '../../../../components/digest/ProjectSettingsScreen';
import { withProjectProvider } from '../../../../components/withProjectProvider';

export default withProjectProvider(ProjectSettingsScreen);
